module.exports = __webpack_public_path__ + "media/apps/mitch-android-1-b6d82a04.png";